import { createReducer } from '@reduxjs/toolkit';

import * as queryPanelActionTypes from '../queryResults/queryResults.actions';
import * as explorePanelActionTypes from './explorePanel.actions';
import { CHART_SELECTIONS, ExplorePanelState } from './models';

const INITIAL_STATE: ExplorePanelState = {
  performanceDataSelectors: null,
  perDataSelectorsLoaded: false,
  perDataSelectorsLoading: false,
  performanceDataSelections: CHART_SELECTIONS,
  errMsg: null
};

const explorePanelReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(queryPanelActionTypes.loadQueryResultsStart, (state) => {
      return {
        ...state,
        performanceDataSelectors: null,
        perDataSelectorsLoading: true,
        perDataSelectorsLoaded: false,
      };
    })
    .addCase(explorePanelActionTypes.loadPDSelectorsStart, (state) => {
      return {
        ...state,
        performanceDataSelectors: null,
        perDataSelectorsLoading: true,
        perDataSelectorsLoaded: false,
      };
    })
    .addCase(explorePanelActionTypes.loadPDSelectorsSuccess, (state, action) => {
      return {
        ...state,
        performanceDataSelectors: action.payload,
        perDataSelectorsLoading: false,
        perDataSelectorsLoaded: true,
        performanceDataSelections: {
          ...CHART_SELECTIONS,
          jurisdictionsSelected: action.payload.defaultJurisID,
          variablesSelected: action.payload.defaultVariableID
        }
      };
    })
    .addCase(explorePanelActionTypes.loadPDSelectorsFailure, (state, action) => {
      return {
        ...state,
        performanceDataSelectors: null,
        perDataSelectorsLoading: false,
        perDataSelectorsLoaded: false,
        errMsg: action.payload
      };
    })
    .addCase(explorePanelActionTypes.changePDSelections, (state, action) => {
      return {
        ...state,
        performanceDataSelections: action.payload
      };
    });
});

export default explorePanelReducer;